import type { AppStages } from '@noah-labs/shared-schema-gql';

type TpConfig = {
  appStage: AppStages;
  commitHash: string;
  datadog: {
    enabled: boolean;
    token: string;
  };
};

let config: TpConfig | undefined;

export function setConfig(cfg: TpConfig): void {
  config = cfg;
}

export function getConfig(): TpConfig {
  if (!config) {
    throw new Error(
      'config for feature-logger is not set, please call `setConfig()` at the start of your application',
    );
  }
  return config;
}
